import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { RootState } from 'store/store';

export const AccessControl = () => {
    const user = useSelector((state: RootState) => state.user.user);

    // Render a router Outlet to allow rendering nested Routes
    return (
        <>{user ? <Outlet/> : null}</>
    );
};
